import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import type React from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
    type: 'partner' | 'community' | 'user';
    className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ type, className }) => {
    const { t } = useTranslation();

    return (
        <div className={cn('flex flex-col items-center justify-center py-4 space-y-2 text-center', className)}>
            <Text className="text-xl text-gray-900 dark:text-gray-50">{t(`${type}PostList.emptyState.title`)}</Text>
            <Text enableMultiline={true} className="text-center text-gray-500 dark:text-gray-500">
                {t(`${type}PostList.emptyState.subtitle`)}
            </Text>
        </div>
    );
};

export default EmptyState;
